// --- Modules
import Node, { payload } from './Node';

class RegisteredDomain extends Node {
  constructor(opts) {
    super(opts);

    Object.defineProperty(this, 'nodeClass', {
      enumerable: false,
      configurable: false,
      writable: false,
      value: 'Registered Domain'
    });
  }
};

export default {
  create: (opts) => {
    let item = new RegisteredDomain(opts);
    payload.nodes.push(item);
    return payload.nodes[payload.nodes.length - 1];
  }
};
